import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "../../styles/scss/components/industrial/video-section.module.scss";
import "lazysizes";
import "lazysizes/plugins/parent-fit/ls.parent-fit";

const VideoSection = ({ id, title, body, videoUrl, thumbnailImage }) => {
  // Extract YouTube video ID from URL
  const getYoutubeId = (url) => {
    if (!url) return null;
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : null;
  };

  const youtubeVideoId = getYoutubeId(videoUrl);
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlayClick = () => {
    setIsPlaying(true);
  };

  return (
    <section id={id} className={styles.videoSection}>
      <div className={styles.container}>
      <div className={styles.videoContainer}>
        {youtubeVideoId ? (
          <>
            {!isPlaying && thumbnailImage && (
              <div className={styles.thumbnailWrapper}>
                <img 
                  src={thumbnailImage}
                  alt={title}
                  className={`${styles.thumbnailImage} lazyload`}
                  data-src={thumbnailImage}
                />
                <button 
                  className={styles.playButton} 
                  onClick={handlePlayClick}
                  aria-label="Play video"
                >
                  <i className="fa fa-play" />
                </button>
              </div>
            )}
            <iframe
              className={`${styles.videoIframe} ${isPlaying ? styles.active : ''}`}
              src={`https://www.youtube.com/embed/${youtubeVideoId}?rel=0&controls=${isPlaying ? 1 : 0}&autoplay=${isPlaying ? 1 : 0}&mute=${isPlaying ? 0 : 1}`}
              title={title || "YouTube video player"}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </>
        ) : thumbnailImage ? (
          <img 
            src={thumbnailImage}
            alt={title}
            className={`${styles.thumbnailImage} lazyload`}
            data-src={thumbnailImage}
          />
        ) : (
          <div style={{ width: "100%", height: "100%", backgroundColor: "#f0f0f0" }}></div>
        )}
      </div>
      
      <div className={styles.contentContainer}>
        {title && <h2 className={styles.title}>{title}</h2>}
        {body && <p className={styles.body}>{body}</p>}
      </div>
      </div>
    </section>
  );
};

VideoSection.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  body: PropTypes.string,
  videoUrl: PropTypes.string,
  thumbnailImage: PropTypes.string
};

export default VideoSection;
